<div class="side-menu">
  <div class="sidebar-mobile-only sidebar-store-env">
    <span class="store-env-label">Store Env:</span>
    <environment-toggler></environment-toggler>
  </div>

  <ul class="menu-list sidebar-mobile-only sidebar-quick-actions">
    <li class="menu-section">
      <ul>
        <li class="menu-item">
          <a
            routerLink="/content-issues"
            class="p-button p-button-text p-mb-1"
            style="width: 100%; text-align: left;"
            (click)="onNavigate()">
            <span class="pi pi-list" style="margin-right: 8px;"></span>
            Content Issues
          </a>
        </li>
        <li class="menu-item">
          <button
            type="button"
            class="p-button p-button-text p-mb-1 cart-menu-button"
            style="width: 100%; text-align: left;"
            (click)="onTransferModal()">
            <span class="pi pi-shopping-cart" style="margin-right: 8px;"></span>
            Store Transfer
            <p-badge
              *ngIf="storeTransferCount > 0"
              [value]="storeTransferCount"
              severity="primary"
              size="small">
            </p-badge>
          </button>
        </li>
        <li class="menu-item">
          <a
            routerLink="/notifications"
            class="p-button p-button-text p-mb-1"
            style="width: 100%; text-align: left;"
            (click)="onNavigate()">
            <span class="pi pi-bell" style="margin-right: 8px;"></span>
            Notifications
          </a>
        </li>
      </ul>
    </li>
  </ul>

  <!--
    Hardcoded rather than DB-driven, following the Notifications precedent above. The menu
    document is seeded by migration_01, which returns early when the document already exists
    (alwaysUpdate: false), so editing that migration would add nothing to any existing
    environment. A DB-driven entry can still be added per environment via
    /settings?tab=dynamicEntities if that is preferred later.
  -->
  <ul class="menu-list" *ngIf="dashboardEnabled">
    <li class="menu-section">
      <ul>
        <li class="menu-item">
          <a
            routerLink="/dashboard"
            class="p-button p-button-text p-mb-1"
            style="width: 100%; text-align: left;"
            (click)="onNavigate()">
            <span class="pi pi-th-large" style="margin-right: 8px;"></span>
            Dashboard
          </a>
        </li>
      </ul>
    </li>
  </ul>

  <ul class="menu-list">
    <ng-container *ngFor="let section of sideMenuItems">
      <li class="menu-section">
        <span class="p-menuitem-text">{{ section.label }}</span>
        <ul>
          <ng-container *ngFor="let item of section.items">
            <!-- Collapsible Menus -->
            <li *ngIf="item.type === 'collapsible'" class="menu-item">
              <button
                type="button"
                class="p-button p-button-text p-mb-1"
                style="width: 100%; text-align: left;"
                (click)="item.expanded = !item.expanded"
              >
                <span
                  class="pi"
                  [ngClass]="item.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
                  style="margin-right: 8px;"
                ></span>
                {{ item.label }}
              </button>
              <ul *ngIf="item.expanded" class="sub-menu">
                <li *ngFor="let sub of item.subMenu" class="menu-item">
                  <a
                    [routerLink]="sub.route"
                    class="p-button p-button-text p-mb-1"
                    style="width: 100%; text-align: left;"
                    (click)="onNavigate()"
                  >
                    {{ sub.label }}
                  </a>
                </li>
              </ul>
            </li>

            <!-- Single Menus -->
            <li *ngIf="item.type !== 'collapsible'" class="menu-item">
              <button
                *ngIf="item.action"
                type="button"
                class="p-button p-button-text p-mb-1"
                style="width: 100%; text-align: left;"
                (click)="handleAction(item.action)"
              >
                <span [class]="item.icon" style="margin-right: 8px;"></span>
                {{ item.label }}
              </button>
              <a
                *ngIf="item.route"
                [routerLink]="item.route"
                class="p-button p-button-text p-mb-1"
                style="width: 100%; text-align: left;"
                (click)="onNavigate()"
              >
                <span [class]="item.icon" style="margin-right: 8px;"></span>
                {{ item.label }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</div>
